import { render, staticRenderFns } from "./GerenciarBancoHorasPage.vue?vue&type=template&id=25730586&scoped=true"
import script from "./GerenciarBancoHorasPage.vue?vue&type=script&lang=js"
export * from "./GerenciarBancoHorasPage.vue?vue&type=script&lang=js"
import style0 from "./GerenciarBancoHorasPage.vue?vue&type=style&index=0&id=25730586&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25730586",
  null
  
)

export default component.exports